import { h } from 'preact';
import * as BaseComp from 'components/bolt/showtimes/showtimesMessage.js';
import { joinClasses, accessNested } from 'utils/utils';
import Store from 'store/store';
import s from 'components/bolt/showtimes/showtimesMessage.sss';
import Button from 'components/bolt/button/button';

export default class ShowtimesMessage extends BaseComp.default {
	//add button with movie styling "get tickets"
	render() {
		const baseJSX = super.render(this.props);
		const dimensions = accessNested(Store.get(), 'client.dimensions');
		if (dimensions?.width >= 765 || dimensions?.height >= 450) return baseJSX;
		const fontStyles = accessNested(Store.get(), 'appData.styling.fontVariables');
		const copy = accessNested(Store.get(), 'appData.copy.baseCopy.$RESIZE_BUTTON') || 'Get Tickets';
		const button = (
			<Button
				type="primary"
				class={joinClasses(s.button, fontStyles.showtimesErrorButton)}
				trigger={() => window.open('https://www.transformersmovie.com/', "_blank", "noreferrer")}
				ariaLabel={copy}
				key="button"
			>
				{copy}
			</Button>
		);
		baseJSX.children.push(button);
		return baseJSX;
	}
}
